import React, { Component } from "react";
import { isMobile } from "../../../js/components/searchform/utils/common";

class SliderDynamicRange extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value || 0,
			step: props.step || 1
		};

		this.handleChange = this.handleChange.bind(this);
		this.valorMaisProximo = this.valorMaisProximo.bind(this);
	}

	componentDidMount() {
		this.setState({ value: this.props.value });
	}
	componentWillReceiveProps(nextProps) {
		this.setState({ value: nextProps.value });
	}

	handleChange(e) {
		e.preventDefault();
		const { validRange } = this.props;

		let value = e.target.value;
		let invalid = validRange && !validRange.find(option => option.value == value);

		this.setState({
			value: value,
			invalid
		});

		if (!invalid) {
			this.props.onChange(value);
		}
	}

	numberWithCommas = (n = 0) => {
		return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
	};

	validRangeText = valid => {
		return this.state.value != this.props.defaultValue ? (
			valid ? (
				<strong>Dentro da faixa</strong>
			) : this.state.invalid ? (
				<strong>Média inválida!</strong>
			) : (
				<strong>Fora da faixa</strong>
			)
		) : (
			<strong>Melhor média</strong>
		);
	};

	valorMaisProximo = e => {
		const { validRange } = this.props;

		if (!validRange) return;

		// Set vars
		let valor = Number(e.target.value),
			lo = 0,
			hi = validRange.length;

		// Find the number
		while (hi - lo > 1) {
			let mid = Math.round((lo + hi) / 2);
			if (validRange[mid].value <= valor) {
				lo = mid;
			} else {
				hi = mid;
			}
		}

		// Set min range
		if (validRange[lo].value >= valor) hi = lo;

		let invalid = validRange && !validRange.find(option => option.value == validRange[hi].value);

		this.setState({
			value: validRange[hi].value,
			invalid
		});

		if (!invalid) {
			this.props.onChange(validRange[hi].value);
		}
	};

	render() {
		const { invalid } = this.state;
		const { className, max, min, step, defaultValue, rangeMin, rangeMax, validRange } = this.props;
		let dataAction = this.props.hasOwnProperty("data-action")
			? this.props["data-action"]
			: "range-offers";
		let valid = this.state.value >= rangeMin && this.state.value <= rangeMax && !invalid;

		let shortRange = rangeMax - rangeMin <= (isMobile() ? 6000 : 3000);

		const style = ["slider-dynamic-range-component d-flex", className].join(" ");

		return (
			<div className={style} data-action={dataAction}>
				<div className="slider-dynamic-range-component--sliders-wrapper">
					<div
						className="slider-dynamic-range-component--sliders-wrapper__slider--left d-flex"
						style={{ flex: rangeMin }}
					/>
					<div
						className="slider-dynamic-range-component--sliders-wrapper__slider--center d-flex"
						style={{ flex: rangeMax - rangeMin }}
					>
						<span>
							{shortRange && rangeMin != rangeMax ? (
								<div className="range-info--center">
									{this.numberWithCommas(rangeMin)} a {this.numberWithCommas(rangeMax)}
								</div>
							) : (
								<div className="range-info--left">{this.numberWithCommas(rangeMin)}</div>
							)}
						</span>
						<span>
							<div className="range-info--right">
								{!shortRange && this.numberWithCommas(rangeMax)}
							</div>
						</span>
					</div>
					<div
						className="slider-dynamic-range-component--sliders-wrapper__slider--right d-flex"
						style={{ flex: max - rangeMax }}
					/>
				</div>

				<div className="slider-dynamic-range-component__slider d-flex">
					<input
						className={`slider-dynamic-range-component__range`}
						type="range"
						onChange={this.handleChange}
						value={this.state.value}
						min={min}
						max={max}
						step={step}
						onMouseUp={e => this.valorMaisProximo(e)}
						onTouchEnd={e => this.valorMaisProximo(e)}
					/>
				</div>
			</div>
		);
	}
}

export default SliderDynamicRange;
